// Manage navigation to tenant feature specific pages

import { NavigateFunction, NavigateOptions } from "react-router-dom";

export const tenantNavigate = ({
    navigate,
    isFeatureEnabled,
    enabledTo,
    disabledTo,
    navigateOptions,
}: {
    navigate: NavigateFunction;
    isFeatureEnabled: boolean;
    enabledTo: string;
    disabledTo: string;
    navigateOptions?: NavigateOptions;
}) => {
    if (isFeatureEnabled) {
        navigate(enabledTo, navigateOptions);
    } else {
        navigate(disabledTo, navigateOptions);
    }
};
